/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityNvdDescription {
    getFixupPrototypeFunction() { return VulnerabilityNvdDescription.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityNvdDescription>): VulnerabilityNvdDescription {
        let obj = Object.assign(new VulnerabilityNvdDescription(), model);
        VulnerabilityNvdDescription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityNvdDescription>): VulnerabilityNvdDescription {
        if (!model) return null;
        return VulnerabilityNvdDescription.newInstance(<VulnerabilityNvdDescription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityNvdDescription) {
        if (!obj) return;

        models.VulnerabilityNvdDescription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityNvdDescription): boolean {
        Object.setPrototypeOf(obj, VulnerabilityNvdDescription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Language of the description
     */
    lang: string;

    /**
     * Value of the description
     */
    value: string;

}
